import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pregunta-opc-valoracion',
  templateUrl: './pregunta-opc-valoracion.component.html',
  styleUrls: ['./pregunta-opc-valoracion.component.scss'],
})
export class PreguntaOpcValoracionComponent  implements OnInit {
  @Input() question: any;
  @Input() valorationType: string = "";
  /** Encuesta de una ruta con el panel de la ruta a la derecha: queda menos ancho, así que se junta más. */
  @Input() roadRightMode: boolean = false;
  /** Encuesta de una ruta con el panel debajo del player (desktop): estrellas / caritas grandes, separación por defecto. */
  @Input() roadBelowMode: boolean = false;
  valorationSelected = "";

  constructor() { }

  /**
   * Las estrellas/caritas se pintan desde `valorationSelected`, no desde `question.answer`, y hasta
   * ahora solo se escribía en `handleChange()`. Mientras las encuestas montan todas sus preguntas de
   * una vez eso basta: la instancia nunca se destruye. Pero una lista virtualizada (swiper con el
   * módulo `virtual`) sí destruye y vuelve a crear la pregunta al salir y volver a entrar en la
   * ventana, y la instancia nueva nacía en blanco aunque la respuesta siguiera guardada. Leer aquí
   * la respuesta previa la repinta; sin respuesta queda `""`, igual que antes.
   */
  ngOnInit() {
    this.valorationSelected = this.question?.answer ?? "";
  }

  handleChange(ev) {
    // console.log("change event: ", ev.target.value);
    this.valorationSelected = ev.target.value;
  }

}
